import entityReducer from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'

import * as types from './action-types'
import type { EmployerBlockEntity } from './types'

export const reducer = entityReducer<EmployerBlockEntity>(
  'employerBlocks',
  {
    [entityTypes.ENTITIES_FETCH_BEGIN]: types.EMPLOYER_BLOCKS_FETCH_BEGIN,
    [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.EMPLOYER_BLOCKS_FETCH_SUCCEEDED,
    [entityTypes.ENTITIES_FETCH_FAILED]: types.EMPLOYER_BLOCKS_FETCH_FAILED,
  },
  {
    idKey: 'id',
    localEntityMap: true,
  },
)
